import { PartnerType } from "../../../models/enums"

const getInitialValues = (storefrontData) => {
  return {
    customerData: {
      partnerType: storefrontData?.customerData?.partnerType || PartnerType.PRIVATE
    }
  }
}

export default getInitialValues